<template>
<el-dialog :visible.sync="dialogVisible" top="0" width="672px" :before-close="closeModal">
    <AlertExclamationRegister size="40" color="#FFAC00" class="d-flex mt-5 mb-2 mx-auto"/>
    <h3 class="c-ndarkthree bold text-center mb-3">
        Não encontramos empresas vinculadas<br> ao seu usuário
    </h3>
    <p class="c-ndarkfour text-center">
        Parece que você não está vinculado a nenhuma empresa na plataforma.<br>
        Entre em contato com o nosso suporte pelos canais indicados abaixo para<br> 
        receber orientações sobre como proceder.
    </p>
    <div class="mt-3 pt-3 mb-3 d-flex justify-content-center">
        <div class="mr-5">
            <caption class="c-nmidone bold">
                Telefone/Whatsapp
            </caption>
            <a :href="`https://wa.me/+${this.getContactWhiteLabel.tel}`" class="p-0">
                <p class="c-ndarkfour bold">
                    {{this.getContactWhiteLabel.tel | formatPhone}}
                </p>
            </a>
        </div>
        <div>
            <caption class="c-nmidone bold">
                Email
            </caption>
            <a :href="`mailto:${this.getContactWhiteLabel.email}`" class="p-0">
                <p class="c-ndarkfour bold">
                   {{this.getContactWhiteLabel.email}}
                </p>
            </a>
        </div>
    </div>
    <span slot="footer" class="dialog-footer d-flex justify-content-end align-items-center">
        <router-link to="" @click.native="closeModal"  :class="`${getPrimaryColor} c-ndarkfour mr-4`">
            Cancelar
        </router-link>
        <button :class="`btn btn-${getPrimaryColor}`" @click="closeModal">
            Ok, entendi
        </button>
    </span>
</el-dialog>
</template>

<script>
import AlertExclamationRegister from '@/components/icons/AlertExclamationRegister'
export default {
    components: {
      AlertExclamationRegister
    },
    props: {
        dialogVisible: {
            required: true,
            type: Boolean,
            default: false
        },
    },
    data() {
        return {}
    },
    methods: {
        closeModal() {
            this.$emit('closeModal', false)
        },
    },
}
</script>

<style>
</style>